const generateDeviceId = () => {
  const getBrowserFingerprint = () => {
    const { userAgent, language, platform, vendor, appVersion } = window.navigator;
    const { colorDepth, pixelDepth } = window.screen;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const cpuCores = navigator.hardwareConcurrency || '';
    const deviceMemory = navigator?.deviceMemory || '';
    
    // Combine all browser-specific values
    const fingerprint = [
      userAgent,
      language,
      platform,
      vendor,
      appVersion,
      colorDepth,
      pixelDepth,
      timezone,
      cpuCores,
      deviceMemory
    ].join('|');

    return fingerprint;
  };

  const generateHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash).toString(36);
  };

  const browserFingerprint = getBrowserFingerprint();
  const hash = generateHash(browserFingerprint);

  return hash;
};

export const getDeviceId = () => {
  // Try to get FingerprintJS ID first (captured in index.html)
  const fingerprintId = localStorage.getItem('x-fingerprint-id');
  if (fingerprintId) {
    return fingerprintId;
  }

  let deviceId = localStorage.getItem('x-device-id');

  if (!deviceId) {
    deviceId = generateDeviceId();
    localStorage.setItem('x-device-id', deviceId);
  }

  return deviceId;
};